import React from "react"

const SiteSubtitle = (props) => {
    return (<h4 className={`text-2xl xl:text-4xl font-raleway font-bold ${props.color ? props.color : 'text-blue'}`} dangerouslySetInnerHTML={{__html: props.subtitle}}/>)
}

export default SiteSubtitle;
